import { Component, Input, OnInit, inject } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { debounce } from 'rxjs/operators';
import { timer } from 'rxjs';

interface AudioPlayerApiConfig {
  polly: {
    baseUrl: string;
  };
}

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss'],
})
export class AudioPlayerComponent implements OnInit {
  private toastController = inject(ToastController);
  private httpClient = inject(HttpClient);

  // This component will get data from polly and set the audio

  @Input() public text: string;
  @Input() public api: AudioPlayerApiConfig;

  public pollyAudio: string | null = null;

  get hasPromptText(): boolean {
    return this.getNormalizedPromptText().length > 0;
  }

  onAudioClick() {
    // Play the audio
    console.log('Clicked');
    if (this.hasPromptText) {
      this.pollyAudio = null;
      this.getPollyAudio();
    }
  }

  ngOnInit() {
    if (this.hasPromptText) {
      // Get audio from polly
      // this.getPollyAudio();
    }
  }

  getPollyAudio() {
    if (!this.hasPromptText) {
      this.showNoTextToast();
      return;
    }

    // Check if this.text starts with and ends with <speak> and </speak> and add them if not
    if (!this.text.startsWith('<speak>')) {
      this.text = '<speak>' + this.text;
    }
    if (!this.text.endsWith('</speak>')) {
      this.text = this.text + '</speak>';
    }

    const pollyAudioObservable = this.httpClient.post(
      this.api.polly.baseUrl,
      {
        text: this.text,
        type: 'ssml',
      },
      { responseType: 'text' },
    );

    pollyAudioObservable.pipe(debounce(() => timer(500))).subscribe({
      next: (pollyAudio: string) => {
        const audioUrl = this.buildAudioUrl(pollyAudio);

        if (!audioUrl) {
          this.toastController
            .create({
              message: 'Invalid audio response from polly',
              duration: 2000,
              position: 'top',
              color: 'danger',
            })
            .then((toast) => toast.present());
          return;
        }

        this.pollyAudio = audioUrl;
      },
      error: () => {
        // Create toast showing error
        this.toastController
          .create({
            message: 'Error getting audio from polly',
            duration: 2000,
            position: 'top',
            color: 'danger',
          })
          .then((toast) => toast.present());
      },
    });
  }

  buildAudioUrl(pollyAudio: string | null | undefined): string | null {
    const normalized = (pollyAudio || '').trim();

    const safeValuePrefix = 'SafeValue must use [property]=binding:';
    const unwrapped = normalized.startsWith(safeValuePrefix) ? normalized.slice(safeValuePrefix.length).trim() : normalized;

    if (!unwrapped || unwrapped === 'undefined' || unwrapped === 'null' || unwrapped.startsWith('<!DOCTYPE html')) {
      return null;
    }

    if (unwrapped.startsWith('data:audio/')) {
      return unwrapped;
    }

    if (unwrapped.startsWith('http://') || unwrapped.startsWith('https://')) {
      return unwrapped;
    }

    return `data:audio/mpeg;base64,${unwrapped}`;
  }

  private getNormalizedPromptText(): string {
    return (this.text || '').replace(/<\/?speak>/gi, '').trim();
  }

  private showNoTextToast(): void {
    this.toastController
      .create({
        message: 'No text to convert to audio',
        duration: 2000,
        position: 'top',
        color: 'danger',
      })
      .then((toast) => toast.present());
  }
}
